import appSettings from './app-settings.json';

export const awsConfig = {
  Auth: {
    region: appSettings.region,
    userPoolId: appSettings.cognitoUserPool,
    userPoolWebClientId: appSettings.cognitoUserPoolWebClientId,
  },
};
